import React from 'react';

const selectAllText = ({ target }) => {
    const range = document.createRange();
    range.selectNode(target);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
}

const ClickSelectText = ({ text }) => (
    <span onClick={selectAllText}>{ text }</span>
);

export default ClickSelectText;